<template>
    <div class="ppv2-flex ppv2-items-center ppv2-gap-2" style="color: #4b5563">
        <svg
            width="15"
            height="15"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        >
            <path d="M1 12C1 12 5 4 12 4C19 4 23 12 23 12C23 12 19 20 12 20C5 20 1 12 1 12Z" />
            <circle cx="12" cy="12" r="3" />
        </svg>
        <span class="ppv2-text-xs poppinsSemiBold ppv2-uppercase" style="color: #6b7280; letter-spacing: 0.08em">
            <slot>{{ $t('widgetIntegration.preview') }}</slot>
        </span>
    </div>
</template>
<script>
export default {
    name: 'PreviewLabel',
}
</script>
